export const router = {
  HOME: '/',
  QUESTION: '/question',
  FAQ: '/faq',
  CONTACT: '/contact-us',
  LEADERBOARD: '/leaderboard',
  INVALID_TOKEN: '/invalid-token',
  PAY_BY_ME_SUCCESS: '/payment-redirect', // Backend related
  PAY_BY_ME_FAILED: '/payment-failed', // Backend related
};
